import React from 'react'
import PropTypes from 'prop-types'

const PageTitle = ({title, subtitle}) => (
    <div className="page-title">
      <h1>{title}</h1>
      {!!subtitle && <p>{subtitle}</p>}
    </div>
);

PageTitle.propTypes = {
  title: PropTypes.string,
  subtitle: PropTypes.string,
};

export default PageTitle;



// WEBPACK FOOTER //
// ./src/components/PageTitle.js